import {
  Avatar,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { AccessProfileStore, CompanyStore, MessageStore } from "store";
import { LoadingLayer } from "../Importation/Layers";
import AccessButton from "./AccessButton";
import ActionsButton from "./ActionsButton";
import CreateEmployees from "./CreateEmployees";

const useStyles = makeStyles((theme) => ({
  backgroundColorPrimary: { backgroundColor: theme.palette.primary.main },
  tableHeadCell: { color: theme.palette.gray[700] },
}));

const Employees = observer(() => {
  const classes = useStyles();
  const [openCreat, setOpenCreat] = useState(false);
  const [loading, setLoading] = useState(false);
  const { employeesList } = CompanyStore;

  useEffect(() => {
    CompanyStore.getCompanysUsers();
    AccessProfileStore.subscribeAccessProfiles();

    return () => {
      AccessProfileStore.unsubscribeAccessProfiles();
    };
  }, []);

  const handleChangeStatus = (uid: string) => (value: boolean) => {
    setLoading(true);
    CompanyStore.setCompanysUserStatus(uid).finally(() => setLoading(false));
  };

  const handleChangeAccess = (userUid: string, profileUid: string) => {
    setLoading(true);

    CompanyStore.setCompanysUserAccess(userUid, profileUid).finally(() =>
      setLoading(false)
    );
  };

  const handleDelete = (uid: string) => () => {
    setLoading(true);
    CompanyStore.deleteCompanysUser(uid).finally(() => setLoading(false));
  };

  const handleOpenLayer = () => {
    if (!CompanyStore.currentCompany) {
      MessageStore.info(
        "É necessário criar uma Empresa antes de cadastrar colaboradores!"
      );
      return;
    }

    setOpenCreat(true);
  };

  const handleCloseLayer = () => {
    setOpenCreat(false);
  };

  if (openCreat) return <CreateEmployees onClose={handleCloseLayer} />;

  return (
    <>
      {loading && (
        <Grid
          container
          xs={12}
          justifyContent="center"
          alignItems="center"
          style={{
            zIndex: 999,
            width: "100vw",
            height: "86vh",
            background: "rgba(255,255,255,.4)",
            marginTop: "-16px",
          }}
        >
          <LoadingLayer message={""} />
        </Grid>
      )}
      <Grid
        container
        item
        xs
        justifyContent="center"
        alignItems="flex-start"
        style={{
          padding: "65px 0px 0px",
          height: "80vh",
          overflow: "hidden",
          overflowY: "scroll",
        }}
      >
        <Grid container item xs={9}>
          <Grid
            container
            item
            xs={12}
            justifyContent="space-between"
            style={{ marginBottom: "25px", height: "52px" }}
          >
            <Typography variant="h4" component="h2" gutterBottom>
              {CompanyStore.currentCompany?.name || ""}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleOpenLayer()}
            >
              {"Cadastrar Colaborador"}
            </Button>
          </Grid>
          {/*  */}
          <Grid container item xs={12}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableHeadCell}
                      colSpan={2}
                      align="left"
                    >
                      {"Nome"}
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="left">
                      {"E-mail"}
                    </TableCell>
                    <TableCell
                      className={classes.tableHeadCell}
                      align="left"
                      width={200}
                    >
                      {"Acesso"}
                    </TableCell>
                    <TableCell
                      className={classes.tableHeadCell}
                      align="left"
                      width={110}
                    >
                      {"Status"}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {employeesList.length < 1 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        {"Não há Colaboradores."}
                      </TableCell>
                    </TableRow>
                  )}
                  {employeesList.map((user, key) => (
                    <TableRow key={key}>
                      <TableCell align="left">
                        <Avatar className={classes.backgroundColorPrimary}>
                          {getInitialLetters(user.name)}
                        </Avatar>
                      </TableCell>
                      <TableCell align="left">{user.name}</TableCell>
                      <TableCell align="left">{user.email}</TableCell>
                      <TableCell align="left">
                        <AccessButton
                          profileUid={user.roleId}
                          onChange={(profileUid) =>
                            handleChangeAccess(user.uid, profileUid)
                          }
                        />
                      </TableCell>
                      <TableCell align="left" width={110}>
                        <ActionsButton
                          disabled={user.disabled}
                          onChangeStatus={handleChangeStatus(user.uid)}
                          onDelete={handleDelete(user.uid)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});

function getInitialLetters(name: string): string {
  const fullName = name.split(" ");
  let initials = fullName[0].charAt(0);

  if (fullName.length > 1) initials += fullName[1].charAt(0);
  return initials.toUpperCase();
}

export default Employees;
